/**
 * Forma dei dati di amministrazione e disposizione della matrice squadre per
 * stagioni (V48). I tipi rispecchiano le risposte di
 * `apps/api/src/servizi/amministrazione.ts`.
 */

import type { FamigliaAttributo } from '@calcio/shared';

export interface Stagione {
  id: string;
  nome: string;
  dataInizio: string;
  dataFine: string;
  corrente: boolean;
  squadre: number;
}

export interface Squadra {
  id: string;
  nome: string;
  attiva: boolean;
  stagioni: number;
}

export interface Cella {
  id: string;
  squadraId: string;
  stagioneId: string;
  categoria: string | null;
  tesserati: number;
}

export interface Matrice {
  stagioni: Stagione[];
  squadre: Squadra[];
  celle: Cella[];
  limite: number;
}

export interface Riga {
  squadra: Squadra;
  /** Una per stagione, nell'ordine delle colonne; null dove l'incrocio manca. */
  celle: (Cella | null)[];
}

/** Riga del catalogo attributi (V52). */
export interface AttributoCatalogo {
  id: string;
  nome: string;
  famiglia: FamigliaAttributo;
  attivo: boolean;
}

/**
 * Una squadra disattivata non riceve nuovi incroci, ma le sue stagioni
 * passate restano da leggere: sparisce solo se non ne ha.
 */
export function righeMatrice(m: Matrice): Riga[] {
  const perChiave = new Map(m.celle.map((c) => [`${c.squadraId}|${c.stagioneId}`, c]));
  return m.squadre
    .map((squadra) => ({
      squadra,
      celle: m.stagioni.map((s) => perChiave.get(`${squadra.id}|${s.id}`) ?? null),
    }))
    .filter((r) => r.squadra.attiva || r.celle.some(Boolean));
}

export const stagionePiena = (s: Stagione, limite: number): boolean => s.squadre >= limite;
